import {ChangeDetectionStrategy, Component, HostBinding, inject, input, Input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {DynamicModule} from 'ng-dynamic-component';
import {NgComponentOutlet} from '@angular/common';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';
import {StoryblokReadMoreComponent} from '@modules/storyblok/components/storyblok-read-more.component';


@Component({
  selector: 'app-card',
  templateUrl: './storyblok-card.component.html',
  styleUrls: ['./storyblok-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicModule, NgComponentOutlet, ReadMoreComponent]
})
export class StoryblokCardComponent extends StoryblokReadMoreComponent implements OnInit {
  protected storyblokComponentService = inject(StoryblokComponentService);
  private storyblokStylingService = inject(StoryblokStylingService);


  readonly body = input<any[]>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();
  readonly id = input<any>();
  readonly background_color = input<any>();

  @Input()
  set elementId(value: any) {
    this.hostElementId = value;
  }

  @HostBinding('attr.id') hostElementId: any;
  @HostBinding('class') class: any;
  @HostBinding('style.background-color') backgroundColor: any;

  components: any;

  constructor() {
    super();
    const storyblokComponentService = this.storyblokComponentService;

    this.components = storyblokComponentService.getComponents();
  }

  ngOnInit() {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), {
      desktop: {
        'margin-bottom': '.5rem',
        'margin-top': '.5rem'
      }
    }, {'col-': 12});
    const background_color = this.background_color();
    if (background_color?.value) {
      this.backgroundColor = background_color.value;
    }
  }
}
